import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Slaaptekort inhalen</title>
                <link rel="canonical" href={route("blogs.tenth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Je hoort regelmatig dat mensen last van slaaptekort hebben. Dit kan door verschillende redenen zijn ontstaan. Wellicht had je een leuk feest of heb je net een belangrijk week achter de rug voor je studie of werk. Hierdoor heb je toch net wat te weinig geslapen en je merkt dat je je vermoeid voelt. Dit fenomeen noemen we slaapschuld, bedacht door de Amerikaanse onderzoeker William C. Dement."
                />
                <meta
                    property="og:description"
                    content="Je hoort regelmatig dat mensen last van slaaptekort hebben. Dit kan door verschillende redenen zijn ontstaan. Wellicht had je een leuk feest of heb je net een belangrijk week achter de rug voor je studie of werk. Hierdoor heb je toch net wat te weinig geslapen en je merkt dat je je vermoeid voelt. Dit fenomeen noemen we slaapschuld, bedacht door de Amerikaanse onderzoeker William C. Dement."
                />
                <meta property="og:url" content={route("blogs.tenth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Slaaptekort inhalen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/slaaptekort-inhalen.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/slaaptekort-inhalen.webp"
                                    type="image/webp"
                                    alt="Slaaptekort inhalen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/slaaptekort-inhalen.jpg"
                                    type="image/jpeg"
                                    alt="Slaaptekort inhalen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/slaaptekort-inhalen.jpg"
                                    alt="Slaaptekort inhalen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Slaaptekort inhalen
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Je hoort regelmatig dat mensen last van slaaptekort
                        hebben. Dit kan door verschillende redenen zijn
                        ontstaan. Wellicht had je een leuk feest of heb je net
                        een belangrijk week achter de rug voor je studie of
                        werk. Hierdoor heb je toch net wat te weinig geslapen en
                        je merkt dat je je vermoeid voelt. Dit fenomeen noemen
                        we slaapschuld, bedacht door de Amerikaanse onderzoeker
                        William C. Dement.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        De volgende dagen ga je een keer extra vroeg te bed of
                        slaap je langer uit dan gewoonlijk om de slaap in te
                        halen. Maar is het wel mogelijk om een slaaptekort te
                        compenseren door daarna een keer langer te slapen?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Effecten slaaptekort
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        In je slaap gebeuren belangrijke processen in je
                        hersenen. Tijdens het slapen word namelijk het contact
                        tussen hersencellen gestimuleerd. Dit heeft effect op
                        het onthouden en op leerprocessen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        In het boek ‘Sleep Thieves’ van Stanley Coren worden
                        resultaten van verschillende onderzoeken aangehaald
                        waaruit blijkt dat een hogere slaapschuld leidt tot een
                        lagere score op een IQ-test. Hoe hoger de slaapschuld,
                        hoe lager de score relatief werd. Zo leidde een
                        slaapschuld van 10 uur verdeeld over 5 nachten tot een
                        score die 15 punten lager lag. In hetzelfde onderzoek
                        word geconcludeerd dat deze score weer omhoogging toen
                        de slaapschuld werd ingehaald. Dit betekent dat dat je
                        op dit vlak je slaaptekort deels kunt inhalen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Hoewel je slaaptekort dus weldegelijk deels in kunt
                        halen kun je sommige negatieve effecten niet volledig
                        compenseren. Je concentratie zal verlaagd blijven
                        ondanks het extra slapen, en je biologische klok kan er
                        ook door in de war raken. Hierdoor heb je in de toekomst
                        weer last van meer slaaptekort.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Nu is het zo dat je lichaam de effecten van een
                        slaapschuld zelf probeert te compenseren. Door een klein
                        aanpassing in de hersenen zul je de dag erop meer diepe
                        slaap krijgen dan normaal gesproken. Dit kwam naar voren
                        bij een onderzoek waarbij ze gebruik maakte van een
                        hersenscan.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Extra slapen
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Is er ook zoiets als het tegenovergesteld van
                        slaapschuld? Ja, dat is er. Het is namelijk mogelijk om
                        van tevoren al extra te slapen als je weet dat je een
                        periode minder zult slapen. Hiermee bouw je een
                        zogeheten slaapbuffer op. Dit compenseert een
                        slaaptekort beter dan achteraf extra proberen te slapen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Een goede nachtrust creëren
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Hoewel je een slaaptekort dus deels kunt compenseren is
                        het ook belangrijk om zo goed mogelijk te slapen. Je
                        kunt namelijk niet zomaar de uren tellen, want diepe
                        slaap bepaalt mede hoe goed uitgerust je bent. Zorg er
                        dus voor dat je rust hebt rond het slapen, zodat je goed
                        in slaap kunt vallen en niet wakker word in de nacht.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
